import { Button } from '@/components/atoms/Button'
import { SaveIcon } from '@/components/atoms/Icons'
import { Panel } from '@/components/atoms/Panel'
import { LabeledInputField, Page } from '@/components/molecules'
import { routes } from '@/config'
import { trpc } from '@/config/trpc'
import { useEffect, useState } from 'react'
import { createSearchParams, generatePath, useNavigate } from 'react-router'
import { USER_UUID_KEY } from '../ApiKeysPage/ApiKeysPage'

function ApiKeysPage() {
  const { mutateAsync } = trpc.addApiUser.useMutation()
  const navigate = useNavigate()

  const [buttonDisabled, setButtonDisabled] = useState(false)
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [timezone, setTimezone] = useState('UTC')
  const [currency, setCurrency] = useState('USD')
  const [validationErrors, setValidationErrors] = useState<string[]>([])

  useEffect(() => {
    setButtonDisabled(!email || !name || !timezone)
  }, [name, email, timezone])

  const handleAddCustomerClick = async () => {
    try {
      setButtonDisabled(true)

      const { status, uuid } = await mutateAsync({
        email,
        name,
        timezone,
        currency,
      })
      if (status === 'Success') {
        window.alert('Created user successfully')
      }
      const wallbreakerUrl = `${generatePath(routes.apiKeys)}?${createSearchParams({ [USER_UUID_KEY]: uuid })}`
      navigate(wallbreakerUrl)
    } catch (e) {
      window.alert(e)
      const message = (e as { message: string }).message
      try {
        setValidationErrors(JSON.parse(message)['validation_errors'])
      } catch {
        setValidationErrors([message])
      }
    } finally {
      setButtonDisabled(false)
    }
  }

  return (
    <Page title="Update data">
      <Panel className="flex flex-col gap-6">
        {validationErrors.map((error) => (
          <Panel key={error} className="bg-red-500/10 text-red-500">
            {error}
          </Panel>
        ))}
        <LabeledInputField id="name" label="Customer Name" value={name} onChange={(e) => setName(e.target.value)} />
        <LabeledInputField id="email" label="Customer Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <div>
          <div className="flex text-base">
            Please use{' '}
            <a
              className="ml-2 text-blue-500"
              href="https://en.wikipedia.org/wiki/List_of_tz_database_time_zones"
              target="_blank"
              rel="noreferrer"
            >
              IANA time zone
            </a>
          </div>
          <LabeledInputField
            id="timezone"
            label="Customer Timezone"
            value={timezone}
            onChange={(e) => setTimezone(e.target.value)}
          />
        </div>

        <div>
          <div className="flex text-base">
            Please use{' '}
            <a
              className="ml-2 text-blue-500"
              href="https://en.wikipedia.org/wiki/ISO_4217"
              target="_blank"
              rel="noreferrer"
            >
              ISO 4217
            </a>
          </div>
          <LabeledInputField
            id="currency"
            label="Customer Currency"
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
          />
        </div>

        <Button
          className="mt-auto gap-2 font-bold text-base"
          onClick={handleAddCustomerClick}
          disabled={buttonDisabled}
        >
          <SaveIcon size={24} />
          Save Customer
        </Button>
      </Panel>
    </Page>
  )
}

export const Component = () => ApiKeysPage()
